<template>
  <!--eslint-disable-next-line vue/no-v-html-->
  <span v-html="sanitizedHtml" />
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import DOMPurify from 'dompurify'
type Props = {
  rawHtml: string
}
const props = defineProps<Props>()
const sanitizedHtml = computed(() => DOMPurify.sanitize(props.rawHtml))
</script>
<style lang="css" scoped>
div {
  hyphens: auto;
}
</style>
